import Script from "next/script";
import { NextSeo } from "next-seo";

import Banner from "lib/components/home/Banner";
import CTASection from "lib/components/home/CTASection";
import Feature1 from "lib/components/home/Feature1";
import Feature2 from "lib/components/home/Feature2";
import Feature3 from "lib/components/home/Feature3";
import LandingHero from "lib/components/home/LandingHero";
import IntercomHelp from "lib/components/IntercomHelp";

const Home = () => {
  return (
    <>
      <NextSeo
        title="Safety Alerts for Garmin inReach, ZOLEO, &amp; Bivy Stick"
        description="Receive real-time severe weather, wildfire, and safety alerts on your Garmin inReach, ZOLEO, or Bivy Stick."
      />
      <Banner />
      <LandingHero />
      <Feature3 />
      <Feature1 />
      <Feature2 />
      <CTASection />

      <Script id="gtag-conversion-home">
        {`
          window.addEventListener('load', function() {
            if (document.location.pathname.includes('/')) {
              gtag('event', 'conversion', {
                'send_to': '${
                  process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_HOME ||
                  "AW-16660393985/twPQCKvZmMsZEIHgpYg-"
                }'
              });
            }
          });
        `}
      </Script>
      <IntercomHelp />
    </>
  );
};

export default Home;
